import { GET_SECTORS, SET_FETECHING, SET_SECTORS_DATA, CRUD_SECTORS, CLEAN_SECTORS_ERROR, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_SECTORS_STATE } from "./types";

const SectorsManagementReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SECTORS:
            return {
                ...state,
                sectorsToConfig: payload.sectorsToConfig,
                isFetching: false,
                responseSectorsService: payload.responseSectorsService
            }
        case CRUD_SECTORS:
            return {
                ...state,
                isFetching: false,
                responseSectorsService: payload.responseSectorsService
            }
        case CLEAN_SECTORS_STATE:
            return {
                ...state,
                sectorData: {
                    sectorId: '',
                    sectorName: '',
                    sectorEnabled: 1,
                },
                responseSectorsService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case SET_SECTORS_DATA:
            return {
                ...state,
                isFetching: false,
                sectorData: payload,
            }
        case CLEAN_SECTORS_ERROR:
            return {
                ...state,
                responseSectorsService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case CHANGE_SETTING:
            return {
                ...state,
                isFetching: false,
                error: payload.error
            }
        case SET_FETECHING:
            return {
                ...state,
                isFetching: payload,
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                openningsToConfig: payload,
            }
        default:
            return state;
    }
}

export default SectorsManagementReducer;